import { render } from "./EikenArticleView.vue?vue&type=template&id=118f4758&scoped=true&ts=true"
import script from "./EikenArticleView.vue?vue&type=script&lang=ts"
export * from "./EikenArticleView.vue?vue&type=script&lang=ts"

import "./EikenArticleView.vue?vue&type=style&index=0&id=118f4758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118f4758"]])

export default __exports__